export const premiumFeatures: string[] = [
  'Join sessions with expert stylists',
  'Shop outfits tailored just for you',
  'Get real-time practical advice',
  'Follow easy-to-use Style Plan',
];
